import arrow from "../../assets/images/right-arrow.svg";
import { useHistory } from "react-router-dom";

import addIcon from '../../assets/images/002-plus.png'
import editIcon from '../../assets/images/001-edit.png';

import "./Title.css";

const Title = ({
  text,
  displayBackButton = false,
  onAddButtonClick = null,
  edit = false
}) => {
  const history = useHistory();

  return (
    <div id="title">
      <div className="clickable">
        {displayBackButton && (
          <div
            onClick={() => {
              history.goBack();
            }}
            className="clickable"
            id="back"
          >
            <img id="backArrow" src={arrow} alt="Back button" />
          </div>
        )}
      </div>
      <h2>{text}</h2>
      <div className="clickable">
        {onAddButtonClick && (
          <div onClick={onAddButtonClick} className="clickable">
            {/* <span id="add">+</span> */}
            <img src={edit ? editIcon : addIcon} alt="" />
          </div>
        )}
      </div>
    </div>
  );
};

export default Title;
